import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Bar, Line, Pie, Doughnut } from 'react-chartjs-2';
import { ChartData } from '../../services/newsFeedService';

// Регистрируем компоненты Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

interface ChartRendererProps {
  type: 'bar' | 'line' | 'pie' | 'doughnut';
  data: ChartData;
  title?: string;
}

const ChartRenderer: React.FC<ChartRendererProps> = ({ type, data, title }) => {
  const commonOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
        labels: {
          font: {
            family: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
            size: 12,
          },
          color: '#333',
        },
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleFont: {
          family: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
        },
        bodyFont: {
          family: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
        },
      },
    },
    scales: type === 'bar' || type === 'line' ? {
      x: {
        ticks: {
          font: {
            family: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
            size: 11,
          },
          color: '#666',
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.1)',
        },
      },
      y: {
        ticks: {
          font: {
            family: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
            size: 11,
          },
          color: '#666',
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.1)',
        },
      },
    } : undefined,
  };

  const renderChart = () => {
    const barOptions = {
      ...commonOptions,
      plugins: {
        ...commonOptions.plugins,
        datalabels: {
          color: 'white',
          font: {
            weight: 'bold' as const,
            size: 12,
          },
          formatter: (value: number) => {
            return value + '%';
          },
        },
      },
    };

    const pieOptions = {
      ...commonOptions,
      plugins: {
        ...commonOptions.plugins,
        datalabels: {
          color: 'white',
          font: {
            weight: 'bold' as const,
            size: 11,
          },
          formatter: (value: number) => {
            return value + '%';
          },
        },
      },
    };

    switch (type) {
      case 'bar':
        return <Bar data={data} options={barOptions} />;
      case 'line':
        return <Line data={data} options={commonOptions} />;
      case 'pie':
        return <Pie data={data} options={pieOptions} />;
      case 'doughnut':
        return <Doughnut data={data} options={pieOptions} />;
      default:
        return <div>Unsupported chart type</div>;
    }
  };

  return (
    <div style={{ 
      width: '100%', 
      height: '300px',
      position: 'relative'
    }}>
      {renderChart()}
    </div>
  );
};

export default ChartRenderer;
